import { Table, TableBody, TableHead, TableRow as TableRowHeader } from '@mui/material';
import NtfRewardItem from '../types/ntf-reward-item.ts';
import TableHeaderCell from '../../common/table-header-cell';
import TableCell from '../../common/table-cell';
import TableRow from '../../common/table-row';
import NftRewardDetailsContainerStyled from './nft-reward-details-container.styled.ts';
import {
  AmountTitle,
  CountTitle,
  TokenTitle,
  MessageTitle,
  NftOwnerAddressTitle,
} from '../../formatted-messages';

type NtfRewardDetailsProps = {
  ntfRewardReportItems: NtfRewardItem[];
};

const NtfRewardDetails: React.FunctionComponent<NtfRewardDetailsProps> = (props: NtfRewardDetailsProps) => {
  return (
    <NftRewardDetailsContainerStyled>
      <Table>
        <TableHead>
          <TableRowHeader>
            <TableHeaderCell align="left">
              <NftOwnerAddressTitle />
            </TableHeaderCell>
            <TableHeaderCell>
              <CountTitle />
            </TableHeaderCell>
            <TableHeaderCell>
              <AmountTitle />
            </TableHeaderCell>
            <TableHeaderCell>
              <TokenTitle />
            </TableHeaderCell>
            <TableHeaderCell>
              <MessageTitle />
            </TableHeaderCell>
          </TableRowHeader>
        </TableHead>
        <TableBody>
          {props.ntfRewardReportItems?.map((ntfRewardItem: NtfRewardItem) => (
            <TableRow key={ntfRewardItem.nftOwnerAddress}>
              <TableCell align="left">{ntfRewardItem.nftOwnerAddress}</TableCell>
              <TableCell>{ntfRewardItem.count}</TableCell>
              <TableCell>{ntfRewardItem.amount}</TableCell>
              <TableCell>{ntfRewardItem.token}</TableCell>
              <TableCell>{ntfRewardItem.comment}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </NftRewardDetailsContainerStyled>
  );
};

export default NtfRewardDetails;
